function escapeRegExpString( str: string ): string {
    return str.replace( /[.*+?^${}()|[\]\\]/g, '\\$&' );
}

export {
    escapeRegExpString,
};
